function count(value) {
  const number = Number(value ?? 0);
  return Number.isFinite(number) ? number : 0;
}

// Search-list responses use *_count; content-detail endpoints also expose
// total_* aliases. Keep one mapping so every search surface shows the same data.
export function searchMetrics(item = {}) {
  return {
    likes: count(item.total_likes ?? item.total_liked ?? item.like_count),
    views: count(item.view_count ?? item.total_views ?? item.total_question_views ?? item.total_lecture_views ?? item.total_note_views),
    reports: item.report_count ?? item.total_reports ?? '0',
    notes: count(item.notes_count ?? item.total_notes ?? item.personal_notes_count),
  };
}
